// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "index/css/" + chunkId + "." + "d5d21c83" + ".css";
};